import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import FilterListIcon from '@material-ui/icons/FilterList';
import { lighten } from '@material-ui/core/styles/colorManipulator';
import Favorite from '@material-ui/icons/Favorite';
import Description from '@material-ui/icons/Description';
import Class from '@material-ui/icons/Class';
import Button from 'components/CustomButtons/Button.jsx';
import { Create } from '@material-ui/icons';
import CloudDownload from '@material-ui/icons/CloudDownload';
import { CSVLink } from "react-csv";




let counter = 0;
// function createData(name, calories, fat, carbs, protein) {
//   counter += 1;
//   return { id: counter, name, calories, fat, carbs, protein };
// }



function createData(questionNumber, answer, A, B, C, D, noAnswer, answerRate) {
  counter += 1;
  return { id: counter, questionNumber, answer, A, B, C, D, noAnswer, answerRate };
}


function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
  return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

const rows = [
  { id: 'questionNumber', numeric: false, disablePadding: true, label: '題號' },
  { id: 'answer', numeric: true, disablePadding: false, label: '答案' },
  { id: 'A', numeric: true, disablePadding: false, label: 'A' },
  { id: 'B', numeric: true, disablePadding: false, label: 'B' },
  { id: 'C', numeric: true, disablePadding: false, label: 'C' },
  { id: 'D', numeric: true, disablePadding: false, label: 'D' },
  { id: 'noAnswer', numeric: true, disablePadding: false, label: '未作答' },
  { id: 'answerRate', numeric: true, disablePadding: false, label: '答對率' }
];





class EnhancedTableHead extends React.Component {
  createSortHandler = property => event => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const { onSelectAllClick, order, orderBy, numSelected, rowCount } = this.props;

    return (
      <TableHead>
        <TableRow>
          {/* <TableCell padding="checkbox">
            <Checkbox
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={numSelected === rowCount}
              onChange={onSelectAllClick}
            />
          </TableCell> */}
          {rows.map(
            row => (
              <TableCell
                key={row.id}
                align={row.numeric ? 'right' : 'left'}
                padding={row.disablePadding ? 'none' : 'default'}
                sortDirection={orderBy === row.id ? order : false}
              >
                <Tooltip
                  title="Sort"
                  placement={row.numeric ? 'bottom-end' : 'bottom-start'}
                  enterDelay={300}
                >
                  <TableSortLabel
                    active={orderBy === row.id}
                    direction={order}
                    onClick={this.createSortHandler(row.id)}
                  >
                    {row.label}
                  </TableSortLabel>
                </Tooltip>
              </TableCell>
            ),
            this,
          )}
        </TableRow>
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const toolbarStyles = theme => ({
  root: {
    paddingRight: theme.spacing.unit,
  },
  highlight:
    theme.palette.type === 'light'
      ? {
        color: theme.palette.secondary.main,
        backgroundColor: lighten(theme.palette.secondary.light, 0.85),
      }
      : {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.secondary.dark,
      },
  spacer: {
    flex: '1 1 100%',
  },
  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: '0 0 auto',
  },
});

let EnhancedTableToolbar = props => {
  const { numSelected, classes } = props;

  return (
    <Toolbar
      className={classNames(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      <div className={classes.title}>
        {numSelected > 0 ? (
          <Typography color="inherit" variant="subtitle1">
            {numSelected} selected
          </Typography>
        ) : (
            <Typography variant="h6" id="tableTitle">
              Nutrition
          </Typography>
          )}
      </div>
      <div className={classes.spacer} />
      <div className={classes.actions}>
        {numSelected > 0 ? (
          <Tooltip title="Delete">
            <IconButton aria-label="Delete">
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        ) : (
            ""
            // <Tooltip title="Filter list">
            //   <IconButton aria-label="Filter list">
            //     <FilterListIcon />
            //   </IconButton>
            // </Tooltip>
          )}
      </div>
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
};

EnhancedTableToolbar = withStyles(toolbarStyles)(EnhancedTableToolbar);

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
  },
  table: {
    minWidth: 1020,
  },
  tableWrapper: {
    overflowX: 'auto',
  },
});

class EnhancedTable extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      order: 'asc',
      orderBy: 'questionNumber',
      selected: [],
      data: [],
      page: 0,
      rowsPerPage: 5,
      dataType: props.dataType
    };

  }


  getData(examlist) {

    var testData = [];
    var exdata = [];
    var examlist = this.state.dataType.userGetReportsData;
    var datakey = this.state.dataType.examinationPaperAnalysisID;
    var reportData = [];
    var reportTempData = [];

    //20181218 目前先排除 E 

    if (examlist.length > 0) {
      var checkExamNumber = examlist.findIndex(img => img.key === datakey);
      if (checkExamNumber > -1) {
        exdata = examlist[checkExamNumber];
        var newData = [];
        if (exdata.value.students) {

          var studentsNumber = (Object.keys(exdata.value.students)).length;

          var students = exdata.value.students;

          var ansTxt = exdata.value.correctAns;
          var ans = ansTxt.split(',');
          var studenstAns = [];
          for (var getstudents in students) {
            var studentAnsTxt = students[getstudents].ans;
            studenstAns.push(studentAnsTxt.split(','));

          }
          //移除班級
          //for (let index = 3; index < ans.length; index++) {
          for (let index = 0; index < ans.length; index++) {


            var mulitAns = "";
            studentsNumber = studenstAns.length;

            for (let j = 0; j < studenstAns.length; j++) {
              var element = studenstAns[j];
              mulitAns += element[index]

            }

            var ansRate = (Math.round((mulitAns.split(ans[index]).length - 1) / (mulitAns.length + (mulitAns.length - studentsNumber)) * 10000) / 100).toFixed(2) + '%';




            var mydata = {
              //移除班級
              // questionNumber: index - 2,
              questionNumber: (index +1) ,
              answer: ans[index],
              A: mulitAns.split('A').length - 1,
              B: mulitAns.split('B').length - 1,
              C: mulitAns.split('C').length - 1,
              D: mulitAns.split('D').length - 1,
              noAnswer: studentsNumber - mulitAns.length,
              answerRate: ansRate,
              //uid: index - 2
              uid: (index +1)
            }

            newData.push(createData(mydata.questionNumber,
              mydata.answer,
              mydata.A,
              mydata.B,
              mydata.C,
              mydata.D,
              mydata.noAnswer,
              mydata.answerRate
            ));
          }

          testData = newData;
        }
      }

    }
    return testData;
  }


  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';

    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }

    this.setState({ order, orderBy });
  };

  handleSelectAllClick = event => {
    if (event.target.checked) {
      this.setState(state => ({ selected: state.data.map(n => n.id) }));
      return;
    }
    this.setState({ selected: [] });
  };

  handleClick = (event, id) => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    this.setState({ selected: newSelected });
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: event.target.value });
  };

  isSelected = id => this.state.selected.indexOf(id) !== -1;

  render() {
    const { classes, dataType } = this.props;
    var data = this.getData(dataType.userGetReportsData);
    var headers = [
      { label: "題號", key: "questionNumber" },
      { label: "答案", key: "answer" },
      { label: "A", key: "A" },
      { label: "B", key: "B" },
      { label: "C", key: "C" },
      { label: "D", key: "D" },
      { label: "未作答", key: "noAnswer" },
      { label: "答對率", key: "answerRate" }
    ];


    // const { data, order, orderBy, selected, rowsPerPage, page } = this.state;
    const { order, orderBy, selected, rowsPerPage, page } = this.state;
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);

    function GetNowTime() {
      var timeDate = new Date();
      var tMonth = (timeDate.getMonth() + 1) > 9 ? (timeDate.getMonth() + 1) : '0' + (timeDate.getMonth() + 1);
      var tDate = timeDate.getDate() > 9 ? timeDate.getDate() : '0' + timeDate.getDate();
      var tHours = timeDate.getHours() > 9 ? timeDate.getHours() : '0' + timeDate.getHours();
      var tMinutes = timeDate.getMinutes() > 9 ? timeDate.getMinutes() : '0' + timeDate.getMinutes();
      var tSeconds = timeDate.getSeconds() > 9 ? timeDate.getSeconds() : '0' + timeDate.getSeconds();
      // return timeDate= timeDate.getFullYear()+'/'+ tMonth +'/'+ tDate +' '+ tHours +':'+ tMinutes +':'+ tSeconds;
      return timeDate = timeDate.getFullYear() + tMonth + tDate + tHours + tMinutes + tSeconds;
    }

    return (
      <Paper className={classes.root}>
        {/* <EnhancedTableToolbar numSelected={selected.length} /> */}
        <Toolbar className={classNames(classes.root)}        >
          <div className={classes.actions}>
            <CSVLink data={data} headers={headers} filename={"試卷分析" + GetNowTime() + ".csv"}>
              {/* <CloudDownload />報表下載 */}
              <Button size="sm" color="primary"><i class="fas fa-cloud-download-alt"></i>報表下載</Button>
            </CSVLink>
          </div>
        </Toolbar>
        <div className={classes.tableWrapper}>
          <Table className={classes.table} aria-labelledby="tableTitle" fixedHeader={false} style={{ width: "auto", tableLayout: "auto", minWidth: (dataType.isMobile ? "800px" : "1020px") }} >
            <EnhancedTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={this.handleSelectAllClick}
              onRequestSort={this.handleRequestSort}
              rowCount={data.length}
            />
            <TableBody>
              {stableSort(data, getSorting(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map(n => {
                  const isSelected = this.isSelected(n.id);
                  return (
                    <TableRow
                      hover
                      onClick={event => this.handleClick(event, n.id)}
                      role="checkbox"
                      aria-checked={isSelected}
                      tabIndex={-1}
                      key={n.id}
                      selected={isSelected}
                    >
                      {/* <TableCell padding="checkbox">
                        <Checkbox checked={isSelected} />
                      </TableCell> */}
                      <TableCell component="th" scope="row" padding="none">
                        {n.questionNumber}
                      </TableCell>
                      <TableCell align="right">{n.answer}</TableCell>
                      <TableCell align="right">{n.A}</TableCell>
                      <TableCell align="right">{n.B}</TableCell>
                      <TableCell align="right">{n.C}</TableCell>
                      <TableCell align="right">{n.D}</TableCell>
                      <TableCell align="right">{n.noAnswer}</TableCell>
                      <TableCell align="right">{n.answerRate}</TableCell>
                    </TableRow>
                  );
                })}
              {emptyRows > 0 && (
                <TableRow style={{ height: 49 * emptyRows }}>
                  <TableCell colSpan={7} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={data.length}
          rowsPerPage={rowsPerPage}
          page={page}
          labelRowsPerPage="筆數"
          labelDisplayedRows={({ from, to, count }) => ` ${from}-${to} 總數 ${count} `}
          backIconButtonProps={{
            'aria-label': 'Previous Page',
          }}
          nextIconButtonProps={{
            'aria-label': 'Next Page',
          }}
          onChangePage={this.handleChangePage}
          onChangeRowsPerPage={this.handleChangeRowsPerPage}
        />
      </Paper>
    );
  }
}

EnhancedTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(EnhancedTable);


// WEBPACK FOOTER //
// ./src/views/NaniExaminationPaperAnalysis/NaniExaminationPaperAnalysis.js